import { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import CreateInstagramModal from './CreateInstagramModal'
import NewInstagramBotCard from '../../components/instagram/NewInstagramBotCard'
import axios from 'axios'

const CreateNewInstagramBot = () => {
  const [selectedBot, setSelectedBot] = useState<any>([])
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [newBotTemplate, setNewBotTemplate] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  const customModalStyles = {
    content: {
      top: '50%',
      left: '43%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-60%',
      transform: 'translate(-30%, -60%)'
    }
  }

  const handleBotSelection = (bot: any) => {
    setSelectedBot([bot])
  }
  console.log(selectedBot.length)
  // Fetch Templates from API
  useEffect(() => {
    const fetchTemplates = async () => {
      // setIsLoading(true)
      try {
        const token = localStorage.getItem('auth-token')
        const response = await axios.get(
          `${process.env.REACT_APP_RESUME_PARSER_URL}/getAllInstagramTemplate`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        )
        if (Array.isArray(response.data)) {
          setNewBotTemplate(response.data)
        }
      } catch (error) {
        console.error('Failed to fetch templates:', error)
      }
    }

    fetchTemplates()
  }, [])

  return (
    <>
      <style>{`
        .instagram-card {
            background-color: #fff;
            padding: 1rem 1.5rem;
            border-top-left-radius: 12px;
             border-top-right-radius: 12px;
            margin-bottom: 0.5rem;
            box-shadow: 0 4px 12px rgba(0,0,0,0.04);
          }

        .templates-container {
            background-color: #ffffff;
            padding: 2rem;
            border-bottom-left-radius: 12px;
            border-bottom-right-radius: 12px;
            box-shadow: 0 8px 30px rgba(0,0,0,0.06);
          }

      `}</style>
      <div style={{ backgroundColor: '#FBF9FF', padding: '2rem 4rem', minHeight: '100vh' }}>
        {/* Page Header */}
        <div className='instagram-card'>
          <div className='d-flex justify-content-between'>
            <div>
              <h1 className='fw-bolder text-dark'>Select Chatbot Template</h1>
              <p className='text-muted fs-6'>Templates help you building your own Chatbot</p>
            </div>
            <div className='d-flex align-items-center'>
              {selectedBot.length > 0 && (
                <button className='btn btn-primary' onClick={openModal}>
                  Select this Template
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Templates Grid */}
        {isLoading ? (
          <div
            className='d-flex justify-content-center align-items-center'
            style={{ height: '50vh' }}
          >
            <div className='spinner-border text-primary'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : (
          <div className='templates-container'>
            <div className='row g-5'>
              {newBotTemplate.length > 0 ? (
                newBotTemplate.map((bot: any, index: number) => (
                  <div className='col-xl-3 col-lg-6' key={bot.id}>
                    <NewInstagramBotCard
                      to='#'
                      name={bot.templateName || 'Car Dealership Bot'}
                      description={
                        bot.description ||
                        'Deploy Car Dealership Bot on car dealership website to interact with visitors & ....'
                      }
                      imageLink={
                        bot.imageLink ||
                        'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png'
                      }
                      onClick={() => handleBotSelection(bot)}
                    />
                  </div>
                ))
              ) : (
                <div className='col-12 text-center p-5'>
                  <p className='text-muted'>No bot templates found.</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* The modal is still here, but now triggered by the card click */}
        <ReactModal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          style={customModalStyles}
          contentLabel='Create Bot'
          appElement={document.getElementById('root') || undefined}
        >
          <CreateInstagramModal closeModal={closeModal} selectedBot={selectedBot} />
        </ReactModal>
      </div>
    </>
  )
}

export default CreateNewInstagramBot
